import HomeNavbar from "../components/HomeNavbar";

interface HomeProps {
    language: string;
    setLanguage: (language: string) => void;

}

const Home = ({ language, setLanguage }: HomeProps) => {
    

    return (
        <div className="relative">
            {/* Navbar */}
            <HomeNavbar language={language} setLanguage={setLanguage} />

            {/* Hero Section */}
            <div
                id="home"
                className="mt-12 min-h-screen flex flex-col items-center justify-center p-8 bg-cover bg-center bg-fixed text-green-950"
                style={{ backgroundImage: "url('/image/Lona2.jpg')" }}
            >
                {/* Logo */}
                <img
                    src="/image/logoTaki.jpg"
                    alt="Logo Chèvrefeuille"
                    className="w-28 md:w-36 mb-6 rounded-full shadow-xl border-4 border-white"
                />

                {/* Title */}
                <h1 className="text-4xl md:text-5xl font-extrabold text-center mb-4 bg-white/80 backdrop-blur-md px-6 py-3 rounded-2xl shadow-lg">
                    {language === "fr"
                        ? "Bienvenue chez Chèvrefeuille Lonicera"
                        : "Welcome to Chèvrefeuille Lonicera"}
                </h1>

                {/* Subtitle */}
                {/* Subtitle */}
                <div className="text-lg md:text-xl max-w-2xl text-center mb-10 space-y-4">
                    <p className="bg-white/70 backdrop-blur-sm p-4 rounded-lg shadow-md">
                        {language === "fr"
                            ? "Découvrez les saveurs vibrantes de la Méditerranée chez Chèvrefeuille Lonicera."
                            : "Discover the vibrant flavours of the Mediterranean at Chèvrefeuille Lonicera."}
                    </p>
                    {/* Main Image */}
                    <img
                        src="/image/Home.jpg"
                        alt="Mediterranean Table"
                        className="rounded-2xl w-full max-w-5xl mb-12 shadow-xl"
                    />

                    <p className="bg-white/70 backdrop-blur-sm p-4 rounded-lg shadow-md">
                        {language === "fr"
                            ? "Notre restaurant propose un délicieux menu brunch alliant tradition et modernité. Rejoignez-nous pour une expérience inoubliable !"
                            : "Our brunch menu combines tradition and modern flair for an unforgettable experience!"}
                    </p>

                    <img
                        src="/image/Table2.jpg"
                        alt="Mediterranean Table"
                        className="rounded-2xl w-full max-w-5xl mb-12 shadow-xl"
                    />
                </div>



            </div>

            {/* About Section */}
            <section className="bg-green-50/90 backdrop-blur-md py-16 px-6 text-center text-green-950">
                <div className="max-w-4xl mx-auto">
                    <h2 className="text-3xl md:text-4xl font-bold mb-4">
                        {language === "fr" ? "Notre voyage culinaire" : "Our Culinary Journey"}
                    </h2>
                    <p className="text-gray-700 text-lg">
                        {language === "fr"
                            ? "Chez Chèvrefeuille Lonicera, nous célébrons les saveurs méditerranéennes. Nos chefs fusionnent traditions et créations modernes pour offrir des plats raffinés et chaleureux."
                            : "At Chèvrefeuille Lonicera, we celebrate Mediterranean flavours. Our chefs blend traditional roots with modern creations to serve refined, heartwarming dishes."}
                    </p>
                </div>
            </section>

            {/* Gallery Section */}
            <section className="py-16 px-6 bg-green-50">
                <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
                    <img
                        src="/image/FIlle.jpg"
                        alt="Serving"
                        className="rounded-xl shadow-lg hover:scale-105 transition-transform"
                    />
                    <img
                        src="/image/Bak.jpg"
                        alt="Baklava"
                        className="rounded-xl shadow-lg hover:scale-105 transition-transform"
                    />
                    <img
                        src="/image/Table.jpg"
                        alt="Brunch Table"
                        className="rounded-xl shadow-lg hover:scale-105 transition-transform"
                    />
                </div>
            </section>

            {/* Footer */}
            {/* Footer */}
            <footer className="bg-green-50/80 backdrop-blur-md py-8 px-4 flex flex-col items-center text-green-950 text-center">
                <img
                    src="/image/petit-logo.jpg"
                    alt="Petit logo Chèvrefeuille"
                    className="w-20 mb-4 rounded-full shadow-md"
                />
                <p className="text-sm md:text-base">
                    {language === "fr"
                        ? `Copyright © ${new Date().getFullYear()} Chèvrefeuille-Lonicera.ca - Tous droits réservés.`
                        : `Copyright © ${new Date().getFullYear()} Chèvrefeuille-Lonicera.ca - All rights reserved.`}
                </p>
            </footer>

        </div>
    );
};

export default Home;
